<template>
  <div v-if="happening"
       @click="action"
       class="
      shadow-lg
      bg-white
      rounded-[15px]
flex-col flex gap-4 w-full"
  >
    <div class="flex flex-row justify-between items-center rounded-t-[15px] h-[32px]"
         :class="[highlightColor === 'blue' ? 'bg-[#2699C6]' : 'bg-brand-orange']">
      <p class="font-bold text-white text-[18px] self-stretch mx-auto my-auto" style="line-height: 24px">
        {{ this.happening.start }} – {{ this.happening.end }}</p>
    </div>
    <div class="flex flex-row mb-4 ml-4">
      <img
        v-if="happening.speaker.photo_url"
        class="object-cover rounded-full w-[90px] h-[90px] mr-4"
        :src="happening.speaker.photo_url"
        :alt="'Profilová fotografie: ' + happening.speaker.name"
        style="aspect-ratio: 1/1"
      />
      <div class="flex flex-col gap-[6px] justify-center">
        <p class="uppercase text-[16px]" style="line-height: normal"
           :class="[highlightColor === 'blue' ? 'text-brand-blue' : 'text-brand-orange']">
          {{ happening.speaker.name }}
        </p>
        <p class="text-[18px] mr-4" style="line-height: normal">{{ truncatedDescription }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from "../Atomic/Radio.vue";
import axios from 'axios';

export default {
  emits: ["update:timeslotSelections"],
  props: {
    happening: {
      type: Object,
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    shouldHaveRadio: {
      type: Boolean
    },

    highlightColor: {
      type: String,
      default: 'orange'
    },
    votingOpened: {
      type: Boolean,
      default: false
    }
  },

  components: {
    RadioButton,
  },

  data() {
    return {
      textTruncateChars: 80,
    };
  },

  methods: {
    action() {
      this.$emit("clicked", {...this.happening, time: this.talkTime()});
    },

    talkTime() {
      if (this.happening.start === undefined) {
        return "Čas přednášky";
      }

      return this.happening.start + "-" + this.happening.end;
    },

    getProperHallName(hallname) {
      if (hallname === "purple") {
        return "Notino sál";
      }

      return "Leadhub sál";
    },

    async removeTimeSlot() {
      if (this.selected === this.happening.hall) {
        const res = await axios.delete(
          `/api/timeslot/${this.happening.timeslot.index}`
        );
        this.$emit("update:timeslotSelections", res.data);
      }
    },
  },

  computed: {
    truncatedDescription() {
      let text = this.happening.annotation;

      if (text.length && text.length > this.textTruncateChars) {
        text = text.substring(0, this.textTruncateChars);
        text += "...";
      }

      return text;
    },

    hasTextOverflow() {
      return this.happening.annotation.length > this.textTruncateChars;
    },

    selected: {
      get() {
        if (
          this.timeslotSelections === undefined ||
          this.timeslotSelections.timeslots === undefined
        ) {
          return "";
        }

        if (
          this.timeslotSelections.timeslots[this.happening.timeslot.index] ===
          null
        ) {
          return "";
        }

        return this.timeslotSelections.timeslots[
          this.happening.timeslot.index
          ] === 0
          ? "heureka"
          : "purple";
      },

      async set() {
        const hallAsString = this.happening.hall === "heureka" ? 0 : 1;

        const res = await axios.post(
          `/api/timeslot/${this.happening.timeslot.index}/${hallAsString}`
        );

        this.$emit("update:timeslotSelections", res.data);
      },
    },
  },
};
</script>

<style>
</style>
